// Lib
import * as Immutable from 'immutable';
import { forEach } from 'lodash';

// Utils
import { getTimestamp } from '../../../common/utils/timeUtil';

// Constants
import { APP_SET_INITIALISED } from './initialisationActions';
import { SOCKET_CONNECT } from '../../utils/socket/socketConstants';

const initialState = Immutable.Map({
    pageLoadTime: getTimestamp(),
    workspaceLoadIdleTime: null,
    currentUser: false,
    remoteUsers: false,
    aliases: false,
    elementCounts: false,
    boardSummaries: false,
    boardHierarchies: false,
    customTemplates: false,
    socketConnection: false,
    appInit: false,
});

const setInitialisedState = (state, action) =>
    state.withMutations((mutableState) => {
        forEach(action.details, (value, property) => {
            mutableState.set(property, value);
        });
    });

export default (state = initialState, action) => {
    switch (action.type) {
        case SOCKET_CONNECT:
            return state.set('socketConnection', true);
        case APP_SET_INITIALISED:
            return setInitialisedState(state, action);
        default:
            return state;
    }
};
